import { ChangeDetectionStrategy, Component, computed, effect, inject, input } from '@angular/core';
import { CurrentCustomerStore } from 'customers-data';
import { PunchOutIntegrationComponentStore } from 'punchout-data';
import { PunchoutIntegrationListViewComponent } from './views/punchout-integration-list-view/punchout-integration-list-view.component';
import { PunchOutIntegration } from '@idealsupply/ngclient-webservice-shopping-cart';

@Component({
  selector: 'ideal-punchout-integration-list',
  imports: [PunchoutIntegrationListViewComponent],
  templateUrl: './punchout-integration-list.component.html',
  styleUrl: './punchout-integration-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [PunchOutIntegrationComponentStore],
})
export class PunchoutIntegrationListComponent {
  private readonly _customerStore = inject(CurrentCustomerStore);
  private readonly _punchoutStore = inject(PunchOutIntegrationComponentStore);
  protected readonly integrations = this._punchoutStore.integrations;

  public readonly customerNumber = input<string | null>(null);
  protected activeCustomerNumber = computed(() => this.customerNumber() ?? this._customerStore.customerNumber());

  constructor() {
    effect(() => this._punchoutStore.selectPunchOutIntegrationByCustomerNumber(this.activeCustomerNumber()));
  }

  protected onIntegrationClicked(integration: PunchOutIntegration) {
    this._punchoutStore.openPunchOutIntegration(integration.id!);
  }
}
